module.exports = __webpack_public_path__ + "static/media/hya-dollar.8dc01778.svg";